import React from 'react';
import './AboutUs.css';


function AboutUs() {
  // Timeline data for company history
  // const timelineEvents = [
  //   {
  //     year: '2017',
  //     title: 'Company Founded',
  //     description: 'Ardency Construction & Trading Sdn. Bhd. was established in April 2017 by Henrie Lee KH to provide quality building materials.'
  //   },
  //   {
  //     year: '2019',
  //     title: 'Expansion',
  //     description: 'Expanded our product offerings and established partnerships with major suppliers across Malaysia.'
  //   },
  //   {
  //     year: '2021',
  //     title: 'Industry Recognition',
  //     description: 'Received recognition for excellence in construction material supply and customer satisfaction.'
  //   },
  //   {
  //     year: '2023',
  //     title: 'Digital Transformation',
  //     description: 'Launched our e-commerce platform to better serve customers with a convenient online ordering system.'
  //   }
  // ];

  return (
    <div className="about-us-container">
      <div className="about-us-wrapper">
        {/* Image and Heading Section*/}
        <section className="about-us-hero-section">
          <div className="about-us-intro-content">
            <h3 className="about-us-subheading">Welcome to</h3>
            <h1 className="about-us-heading">
              Ardency Construction & Trading Sdn. Bhd.
            </h1>
          </div>

          <div className="about-us-image-container"> 
            <img
              className="about-us-main-image"
              src="./ardency-building.jpg"
              alt="About Us"
            />
          </div>
        </section>

        {/* Description Section */}
        <section className="about-us-description-section">
          <div className="about-us-description-accent about-us-description-accent-1"></div>
          <div className="about-us-description-accent about-us-description-accent-2"></div>
          <div className="about-us-description">
            <p>
              At Ardency Construction & Trading, we are more than just a distributor of building materials — we are your dedicated partner in construction. As a reliable distributor of building materials, we support builders, developers, and contractors in creating lasting structures, and we're committed to helping you complete your projects smoothly — with the right materials, the right price, and the right timing.
            </p>
            <p>
              We specialize in a comprehensive range of building materials to meet the diverse needs of the construction industry. Whether you're building a home, a commercial development, or infrastructure projects, we supply trusted and quality materials – all in one place.
            </p>
            <p>
              From essential building materials like cement items, precast concrete products, steel products, timber products, water & sewerage products, bricks, blocks & pavers, sand & quarry products, sanitary wares, tiles products, doors & ironmongeries, roofing materials and etc - we've got it all under one roof.
            </p>
            <p>
              Thank you for choosing us as your partner in building the future.
            </p>
            <p>
              <div className="about-us-description-2">
                <b>Efficient Distributor • Your Building Materials Partner</b>
              </div>
            </p>
          </div>
        </section>

        {/* Cards Section - Vision, Mission, Plan */}
        <section className="about-us-cards-section">
          {/* Vision Card */}
          <div className="about-us-card">
            <div className="about-us-card-content">
              <div className="about-us-card-icon">
                <img 
                  src="./vision.png" 
                  alt="Vision Icon" 
                  style={{width: '40px', height: '40px', filter: 'invert(1)'}}
                />
              </div>
              <h3 className="about-us-card-heading">
                Our Vision
              </h3>
              <ul className="about-us-card-list">
                <p className="about-us-card-list-item-none">
                  To become Malaysia's leading one-stop platform for construction materials – combining digital convenience, supply chain excellence, and strong industry expertise to build better, faster, and smarter together with our clients.
                </p>
              </ul>
            </div>
          </div>

          {/* Mission Card */}
          <div className="about-us-card">
            <div className="about-us-card-content">
              <div className="about-us-card-icon">
                <img 
                  src="./mission.png" 
                  alt="Mission Icon" 
                  style={{width: '40px', height: '40px', marginLeft:'2px'}}
                />
              </div>
              <h3 className="about-us-card-heading">
                Our Mission
              </h3>
              <ul className="about-us-card-list">
                <li className="about-us-card-list-item-none">
                  We strive to be your premier one-stop building materials supplier by delivering superior quality, competitive prices, and efficient services that exceeds expectations. We are committed to expanding our distribution network regionally and nationally to provide exceptional service that meets our customers' evolving needs.
                </li>
              </ul>
            </div>
          </div>

          {/* Plan Card */}
          {/* <div className="about-us-card">
            <div className="about-us-card-content">
              <div className="about-us-card-icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#6f9ac2" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 16V8a2 2 0 00-1-1.73l-7-4a2 2 0 00-2 0l-7 4A2 2 0 003 8v8a2 2 0 001 1.73l7 4a2 2 0 002 0l7-4A2 2 0 0021 16z"></path>
                  <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
                  <line x1="12" y1="22.08" x2="12" y2="12"></line>
                </svg>
              </div>
              <h3 className="about-us-card-heading">
                Our Plan
              </h3>
              <ul className="about-us-card-list">
                <li className="about-us-card-list-item">
                  Providing excellent services coupled with innovation ideas in order to achieve the target of our customers' need - to maximisation of profit.
                </li>
                <li className="about-us-card-list-item">
                  E - Commerce, One of the greatest sales tool, which is One of the Main FOCUS POINT to enhance our reputation and achieve the sales growth of the company.
                </li>
                <li className="about-us-card-list-item">
                  Continuity of enhancing products ranges and scope coupled with future products innovation in order to strike the market with greater efficiency.
                </li>
              </ul>
            </div>
          </div> */}
        </section>

        <img
          className="about-us-dots-lower"
          src="./aw3.svg"
          alt="Decorative dots"
        />
      </div>

      {/* Company Timeline Section */}
      {/* <section className="about-us-timeline-section">
        <div className="about-us-section-header">
          <h2 className="about-us-section-title">Our Journey</h2>
          <div className="about-us-section-divider"></div>
        </div>

        <div className="about-us-timeline">
          {timelineEvents.map((event, index) => (
            <div className={`about-us-timeline-item ${index % 2 === 0 ? 'left' : 'right'}`} key={index}>
              <div className="about-us-timeline-marker"></div>
              <div className="about-us-timeline-content">
                <div className="about-us-timeline-year">{event.year}</div>
                <h3 className="about-us-timeline-title">{event.title}</h3>
                <p className="about-us-timeline-description">{event.description}</p>
              </div>
            </div>
          ))}
        </div>
      </section> */}

      <section className="about-us-timeline-section">
        <div className="about-us-section-header">
          <h2 className="about-us-section-title">Why Choose Ardency?</h2>
          <div className="about-us-section-divider"></div>
        </div>

        <div className="about-us-timeline">
          <ul className="about-us-card-list-choose">
            <li className="about-us-card-list-item">
              Wide Product Range
            </li>
             <li className="about-us-card-list-item">
              Reliable products
            </li>
             <li className="about-us-card-list-item">
               Competitive prices
            </li>
             <li className="about-us-card-list-item">
              Experienced Industry Team
            </li>
          </ul>  
          <p className="about-us-card-list-item-left"> When you choose Ardency as your Building Materials Partner, you're choosing a company that values your time as much as you do. Because in building, efficiency isn't just convenient – it's foundational.</p>
          <p><b>Your One-Stop Building Materials Supplier</b></p>
          <p>Quality • Efficiency • Nationwide Delivery</p>
        </div>
      </section>

    </div>
  );
}

export default AboutUs;